import { TuningProfileField } from '../../../../models/TuningProfile.model'

// short labels for table headers and per-field counts
export const tuningProfileFieldLabels: Record<TuningProfileField, string> = {
  weatherResistance: 'Resistance',
  precipitationLookbackDays: 'Lookback',
  saturationModifier: 'Saturation',
  dryTimeModifier: 'Dry-Time',
}

// the order fields are shown in, matching the trail form
export const tuningProfileTrailFields: TuningProfileField[] = [
  'weatherResistance',
  'precipitationLookbackDays',
  'saturationModifier',
  'dryTimeModifier',
]

export const tuningProfileSystemFieldLabels: Partial<Record<TuningProfileField, string>> = {
  precipitationLookbackDays: 'Precipitation Lookback',
  dryTimeModifier: 'Dry-Time Modifier',
  saturationModifier: 'Saturation Modifier',
}

/**
 * @description Formats a tuning value for display. A blank (null) trail value uses its trail system's;
 * a blank trail system lookback uses the region's, and blank trail system modifiers use the default of 1.
 */
export const formatTuningValue = (
  field: TuningProfileField,
  value: number | null,
  level: 'trailSystem' | 'trail',
): string => {
  if (value === null) {
    if (level === 'trail') {
      return 'System'
    }
    return field === 'precipitationLookbackDays' ? 'Region default' : 'Default (1)'
  }
  if (field === 'precipitationLookbackDays') {
    return `${value} ${value === 1 ? 'day' : 'days'}`
  }
  return String(value)
}
